module.exports = __webpack_public_path__ + "4f4bae373847ca5ffbae12e4d706f54b.MP3";